import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'post-change-review';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Post Change Review',
};

const postChangeReview = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { postChangeReview };
